import type { NeoOpeningHour, NeoStore } from '@expert/types';
import { ProvideNames } from '../statics';

export const mapStoreFromNeoStore = (neoStore: NeoStore, additionalInfo?: { storeLogoImg?: string, storeLogoDarkImg?: string }): Store => {
    const expStore: Store = {
        id: neoStore.id,
        name: neoStore.name,
        email: neoStore.mail,
        street: neoStore.street,
        zip: neoStore.zip,
        city: neoStore.city,
        phone: neoStore.phone,
        majorCustomerPhone: neoStore.telefax,
        represantiveName: neoStore.represantiveName,
        companyGroupId: neoStore.expCompanyGroupId,
        cartSwapOnlineReservation: neoStore.cartSwapOnlineReservation,
        storeId: neoStore.expId,
        storeLink: neoStore.urlPart || '',
        storeLogo: neoStore.logo,
        position: {
            lat: neoStore.latitude,
            lng: neoStore.longitude,
        },
        storeLogoImg: additionalInfo?.storeLogoImg ?? ProvideNames.DEFAULT_CENTRAL_STORE.storeLogoImg,
        storeLogoDarkImg: additionalInfo?.storeLogoDarkImg ?? ProvideNames.DEFAULT_CENTRAL_STORE.storeLogoDarkImg,
        fbPixelId: neoStore.fbPixelId,
        videoConsultation: neoStore.videoConsultation ?? false,
        showAlternativeAvailabilityForStores: neoStore.showAlternativeAvailabilityForStores,
        institutionMappings: neoStore.institutionMappings,
        openings: neoStore.openingHours,
        paybackStore: neoStore.paybackStore,
    };

    expStore.openingHours = expStore.openings?.map((openingHour: NeoOpeningHour) => {
        return {
            dayFrom: openingHour.dayFrom?.toLowerCase()?.substring(0, 2),
            dayTo: openingHour.dayTo?.toLowerCase()?.substring(0, 2),
            comment: openingHour.comment,
            timeFrom: convertMinutesToTimeString(openingHour.timeFrom),
            timeTo: convertMinutesToTimeString(openingHour.timeTo),
        }
    });

    return expStore;
};

export const convertMinutesToTimeString = (number: number): string => {
    return `${("0" + Math.floor(number / 60)).slice(-2)}:${("0" + number % 60).slice(-2)}`;
};